"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchResults = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _Style = _interopRequireDefault(require("../components/Style"));

var _SearchPagination = _interopRequireDefault(require("../components/SearchPagination"));

var _actions = require("../store/actions");

var _searchResults = require("../store/reducers/searchResults");

var _styles = _interopRequireDefault(require("../styles"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SearchResults =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchResults, _PureComponent);

  function SearchResults() {
    _classCallCheck(this, SearchResults);

    return _possibleConstructorReturn(this, _getPrototypeOf(SearchResults).apply(this, arguments));
  }

  _createClass(SearchResults, [{
    key: "handleSearchResultClick",
    value: function handleSearchResultClick(articleId) {
      var searchQuery = this.props.searchQuery;
      this.props.trafficArticleClick({
        articleId: articleId,
        from: 'search'
      });
      this.props.trafficSearchResultClick({
        articleId: articleId,
        query: searchQuery
      });
    }
  }, {
    key: "handleSearchResultsViewed",
    value: function handleSearchResultsViewed() {
      var _this$props = this.props,
          searchPage = _this$props.searchPage,
          searchQuery = _this$props.searchQuery,
          searchResults = _this$props.searchResults;
      var searchResultsPage = searchResults && searchResults[searchPage];

      if (searchResultsPage) {
        this.props.trafficSearchResultsView({
          count: searchResultsPage.total,
          page: searchPage,
          query: searchQuery,
          results: searchResultsPage.results.map(function (result) {
            return String(result.id);
          })
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          market = _this$props2.market,
          searchPage = _this$props2.searchPage,
          searchQuery = _this$props2.searchQuery,
          searchResults = _this$props2.searchResults;
      var searchResultsPage = searchResults && searchResults[searchPage];
      this.handleSearchResultsViewed();
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "help--search-results-container"
      }, searchResultsPage && searchResultsPage.results && _react.default.createElement("div", {
        className: "help--search-results-query"
      }, market === _constants.MARKET_EN_US ? _react.default.createElement("span", null, "".concat(searchResultsPage.total, " results for "), _react.default.createElement("b", null, "\"".concat(searchQuery, "\""))) : _react.default.createElement("span", null, _react.default.createElement("b", null, "\"".concat(searchQuery, "\" ")), "(".concat(searchResultsPage.total, ")")), market === _constants.MARKET_EN_US ? _react.default.createElement("span", null, ", page ", searchPage) : _react.default.createElement("span", null, " - ", searchPage), searchResultsPage.suggest && searchResultsPage.suggest.text && _react.default.createElement("span", null, " suggestion: ", _react.default.createElement("b", null, "\"", searchResultsPage.suggest.text, "\""))), searchResultsPage && searchResultsPage.results && searchResultsPage.results.map(function (searchResult) {
        return _react.default.createElement("div", {
          className: "help--search-result-item",
          key: searchResult.id
        }, _react.default.createElement(_reactRouterDom.Link, {
          className: "help--search-result-item-link",
          to: "/article/".concat(searchResult.id),
          onClick: function onClick() {
            return _this.handleSearchResultClick(searchResult.id);
          }
        }, _react.default.createElement("div", {
          className: "help--search-result-item-title",
          dangerouslySetInnerHTML: {
            __html: searchResult.title
          }
        })), _react.default.createElement("div", {
          className: "help--search-result-item-text",
          dangerouslySetInnerHTML: {
            __html: searchResult.text
          }
        }));
      }), searchResultsPage && searchResultsPage.results && _react.default.createElement(_SearchPagination.default, {
        itemCount: searchResultsPage.total
      }), !searchResultsPage && _react.default.createElement("div", {
        className: "help--search-results-loading"
      })), _react.default.createElement(_Style.default, {
        css: "\n            .help--search-results-container {\n              padding: 0.8em 1.5em 1.5em 1.5em;\n            }\n            .help--search-results-query {\n              color: #757575;\n              font-size: 0.85em;\n              margin-bottom: 1.5em;\n            }\n            .help--search-result-item:not(:last-child) {\n              margin-bottom: 1.25em;\n            }\n            .help--search-result-item-title {\n              font-size: 1.1em;\n            }\n            .help--search-result-item-text {\n              font-size: 0.85em;\n            }\n            .help--search-results-loading {\n              height: calc(100vh - ".concat(_styles.default.sizes.search, "px);\n            }\n          ")
      }));
    }
  }]);

  return SearchResults;
}(_react.PureComponent);

exports.SearchResults = SearchResults;
SearchResults.propTypes = {
  market: _propTypes.default.string,
  searchPage: _propTypes.default.string.isRequired,
  searchQuery: _propTypes.default.string.isRequired,
  searchResults: _searchResults.searchResultsPropType,
  trafficArticleClick: _propTypes.default.func.isRequired,
  trafficSearchResultClick: _propTypes.default.func.isRequired,
  trafficSearchResultsView: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
      query = _ownProps$match$param.query,
      page = _ownProps$match$param.page;
  return {
    market: state.app.market,
    searchPage: page,
    searchQuery: query,
    searchResults: state.searchResults[query]
  };
};

var mapDispatchToProps = {
  trafficArticleClick: _actions.trafficArticleClick,
  trafficSearchResultClick: _actions.trafficSearchResultClick,
  trafficSearchResultsView: _actions.trafficSearchResultsView
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchResults);

exports.default = _default;